import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { id: "bounty" }
const _hoisted_2 = { class: "bounty-list" }
const _hoisted_3 = ["id"]
const _hoisted_4 = { class: "bounty-card bounty-front" }
const _hoisted_5 = { class: "bounty-info" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "sub-title" }
const _hoisted_8 = { class: "text" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "bounty-card bounty-back" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "bounty-name" }, "- 赏金任务 -", -1)

import {
  bountyList,
  flipStage,
  finishBounty,
  initBounty
} from "@/assets/ts/bounty";


export default /*#__PURE__*/_defineComponent({
  __name: 'BountyView',
  setup(__props) {


initBounty();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bountyList), (bounty, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "bounty-box",
          key: index
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["bounty-item", {'flip': _unref(flipStage)[index]}]),
            id: 'bounty-' + (index + 1)
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_6, _toDisplayString(bounty.valueName), 1),
                  _createElementVNode("p", _hoisted_7, _toDisplayString(bounty.name), 1)
                ]),
                _createElementVNode("p", _hoisted_8, _toDisplayString(bounty.description), 1),
                (bounty.id !== 'V0')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "button",
                      onClick: ($event: any) => (_unref(finishBounty)(index))
                    }, "已完成", 8, _hoisted_9))
                  : _createCommentVNode("", true)
              ])
            ]),
            _hoisted_10
          ], 10, _hoisted_3),
          _hoisted_11
        ]))
      }), 128))
    ])
  ]))
}
}

})